const TerminalLine = ({ type = "response", text = "", showCursor = false, className = "" }) => {
  const cursor = showCursor
    ? <span className="inline-block w-[2px] h-[1em] bg-[#AC8E66] ml-[1px] align-middle animate-cursor-blink" />
    : null;

  if (type === "prompt") {
    return (
      <p className={`text-sm sm:text-base text-[#EFEBDC]/60 mt-3 first:mt-0 ${className}`}>
        <span className="text-[#AC8E66]">$</span>
        {text.startsWith("$") ? text.slice(1) : ` ${text}`}
      </p>
    );
  }

  if (type === "error") {
    return (
      <p className={`text-sm sm:text-base text-[#ff6b6b] mt-1 flex items-start gap-2 ${className}`}>
        <span className="text-[#ff6b6b]/60 flex-none">&gt;</span>
        <span className="min-w-0 flex-1">
          {text.startsWith(">") ? text.slice(1) : ` ${text}`}
          {cursor}
        </span>
      </p>
    );
  }

  if (type === "status") {
    return (
      <p className={`text-sm sm:text-base text-green-400 mt-1 ${className}`}>
        <span className="text-green-400/70">&gt;</span>
        {text.startsWith(">") ? text.slice(1) : ` ${text}`}
        {cursor}
      </p>
    );
  }

  if (type === "warning") {
    return (
      <p className={`text-sm sm:text-base text-orange-400 mt-1 ${className}`}>
        <span className="text-orange-400/60">&gt;</span>
        {text.startsWith(">") ? text.slice(1) : ` ${text}`}
        {cursor}
      </p>
    );
  }

  // default: response
  return (
    <p className={`text-sm sm:text-base text-[#EFEBDC]/80 mt-1 flex items-start gap-2 ${className}`}>
      <span className="text-[#AC8E66]/70 flex-none">&gt;</span>
      <span className="min-w-0 flex-1">
        {text.startsWith(">") ? text.slice(1) : ` ${text}`}
        {cursor}
      </span>
    </p>
  );
};

export default TerminalLine;
